import React, { useState, useEffect } from "react";
import {
  Box, Typography, Grid, TextField, Button, MenuItem, Paper, Drawer, CircularProgress,
  List, ListItemText, IconButton, AppBar, Toolbar, InputAdornment,
  Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, Snackbar, SnackbarContent,
  ListItem,
} from "@mui/material";
import {
  Delete, PriorityHigh, Close, Search, Work, LocationOn, Description, Add, History, Send, Hub, HelpOutline,
} from "@mui/icons-material";
import ReactMarkdown from 'react-markdown';
import { motion } from "framer-motion";
import axios from "axios";
import utils from '../../utils';

const categorie = [
  "Industria", "Commercio", "Servizi", "Sanità",
  "Pubblica Amministrazione", "Agricoltura", "Edilizia",
  "Turismo", "Trasporti", "Istruzione", "Informatica",
  "Energia", "Telecomunicazioni"
];

const regioni = [
  "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna",
  "Friuli Venezia Giulia", "Lazio", "Liguria", "Lombardia", "Marche",
  "Molise", "Piemonte", "Puglia", "Sardegna", "Sicilia", "Toscana",
  "Trentino-Alto Adige", "Umbria", "Valle d'Aosta", "Veneto"
];

const benvenuto = "Benvenuto, seleziona il settore e la regione di interesse, poi descrivi il ruolo per ottenere una stima dei costi";

const Dashboard = ({ conversazioni, eliminaConversazione, onClose, visualizzaItem, isOp, ragioniSociali }) => {
  const [query, setQuery] = useState("");

  const conversazioniFiltrate = conversazioni.filter((c) =>
    c.payload.req.descrizione.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <Drawer anchor="right" open={true} onClose={onClose}>
      <Box sx={{ width: 350 }}>
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Storico Richieste
            </Typography>
            <IconButton edge="end" color="inherit" onClick={onClose}>
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box p={2}>
          <TextField
            label="Cerca"
            variant="outlined"
            fullWidth
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <List>
          {conversazioniFiltrate.map((c) => (
            <ListItem
              button
              key={c.id}
              onClick={() => visualizzaItem(c)}
              sx={{
                backgroundColor: c.consulenza ? "rgba(255, 0, 0, 0.1)" : "inherit",
                borderRadius: 1, // un po' di arrotondamento se vuoi
                mb: 1, // margine sotto per distanziarli un po'
              }}
              secondaryAction={
                c.consulenza ? (
                  <Tooltip title="Richiesta consulenza">
                    <IconButton onClick={(e) => e.stopPropagation()}>
                      <PriorityHigh color="error" />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <IconButton onClick={(e) => {
                    e.stopPropagation();
                    eliminaConversazione(c.id);
                  }}>
                    <Delete />
                  </IconButton>
                )
              }
            >
              <ListItemText
                primary={c.payload.req.descrizione.substring(0, 30) + "..."}
                secondary={`${new Date(c.timestamp).toLocaleDateString()} ${isOp ? ragioniSociali[c.utente_id] : ''}`}
              />
            </ListItem>
          ))}
        </List>

      </Box>
    </Drawer>
  );
};

export default function PrevisioneCostiConDashboard({ isOp = false }) {
  const [testoBenvenuto, setBenvenutoTesto] = useState("");
  const [categoria, setCategoria] = useState("");
  const [regione, setRegione] = useState("");
  const [descrizione, setDescrizione] = useState("");
  const [risposta, setRisposta] = useState("");
  const [scrittura, setScrittura] = useState(false);
  const [conversazioni, setConversazioni] = useState([]);
  const [dashboardAperta, setDashboardAperta] = useState(false);
  const [nuovaDialogAperta, setNuovaDialogAperta] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [mostraRisposta, setMostraRisposta] = useState(false);
  const [openDialogConferma, setOpenDialogConferma] = useState(false);
  const [ragioniSociali, setRagioniSociali] = useState({});

  useEffect(() => {
    const loadConversazioni = async () => {
      try {
        const res = await axios.get('/api/previsionicosti', {
          headers: utils.getAuthHeaders(),
        });
        const { success, data } = res.data;
        if (success) {
          setConversazioni(data);
        } else {
          setError("Errore nel caricamento delle conversazioni.");
        }
      } catch (error) {
        setError("Si è verificato un errore imprevisto sul nostro server.");
        console.log(error);
      }
    };

    let i = 0;
    const scrivi = () => {
      if (i < benvenuto.length) {
        setBenvenutoTesto(benvenuto.substring(0, i + 1));
        i++;
        setTimeout(scrivi, 15);
      }
    };

    const fetchRagioniSociali = async () => {
      try {
        const res = await axios.get(`/api/aziendeeop`, {
          headers: utils.getAuthHeaders(),
        });
        const { success, error } = res.data;
        if (success) {
          const dizionario = {};
          for (const az of res.data.aziende) {
            dizionario[az.id] = az.nome;
          }
          setRagioniSociali(dizionario);
        } else {
          setError(error);
        }
      } catch (error) {
        setError(
          "Si è verificato un errore imprevisto sul nostro server."
        );
        console.log(error);
      }
    }

    scrivi();
    loadConversazioni();
    if (isOp) {
      fetchRagioniSociali();
    }
  }, []);

  const handleInvia = async () => {
    setScrittura(true);
    setRisposta("");
    setMostraRisposta(false);

    const reqPayload = {
      regione,
      settore: categoria,
      descrizione
    };

    try {
      const res = await axios.post('/api/creaprevisionecosti', reqPayload, {
        headers: utils.getAuthHeaders(),
      });
      const { success, data, error: apiError } = res.data;
      if (success) {
        const responseText = data.payload.res;
        setScrittura(false);
        setMostraRisposta(true);
        let i = 0;
        const scrivi = () => {
          if (i < responseText.length) {
            setRisposta(responseText.substring(0, i + 1));
            i++;
            setTimeout(scrivi, 15);
          } else {
            setConversazioni(prev => [...prev, data]);
          }
        };
        scrivi();
      } else {
        setError(apiError || "Errore nella creazione della previsione.");
      }
    } catch (error) {
      setError("Si è verificato un errore imprevisto sul nostro server.");
      console.log(error);
    } finally {
      setScrittura(false);
    }
  };

  const eliminaConversazione = async (id) => {
    try {
      const res = await axios.post('/api/eliminaprevisionecosti', { id }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error: apiError } = res.data;
      if (success) {
        setConversazioni(prev => prev.filter(c => c.id !== id));
        setSuccessMessage("Previsione eliminata con successo!");
      } else {
        setError(apiError || "Errore nell'eliminazione della conversazione.");
      }
    } catch (error) {
      setError("Si è verificato un errore imprevisto sul nostro server.");
      console.log(error);
    }
  };

  const avviaNuovaRichiesta = () => {
    setCategoria("");
    setRegione("");
    setDescrizione("");
    setRisposta("");
    setMostraRisposta(false);
    setNuovaDialogAperta(false);
  };

  const handleRichiediConsulenza = async (conversazioneId) => {
    try {
      const res = await axios.post('/api/richiediconsulenza', { id: conversazioneId }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error: apiError } = res.data;
      if (success) {
        setConversazioni(prev =>
          prev.map(c =>
            c.id === conversazioneId ? { ...c, consulenza: true } : c
          )
        );
        setSuccessMessage("Richiesta di consulenza inviata con successo!");
      } else {
        setError(apiError || "Errore nella richiesta di consulenza.");
      }
    } catch (error) {
      setError("Si è verificato un errore imprevisto sul nostro server.");
      console.log(error);
    }
    setOpenDialogConferma(false);
  };

  const visualizzaItemFun = (item) => {
    setCategoria(item.payload.req.settore);
    setRegione(item.payload.req.regione);
    setDescrizione(item.payload.req.descrizione);
    setRisposta(item.payload.res);
    setMostraRisposta(true);
  }

  return (
    <Box display="flex">
      <Box p={4} flex={1}>

        {/* Header con bottoni */}
        <Box display="flex" flexDirection={{ xs: "column", md: "row" }} alignItems="center">
          <IconButton color="primary">
            <Hub />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 1, fontWeight: 'bold' }}>
            Previsione Costi
          </Typography>
          <Box display="flex" alignItems="center" flex={1}>
            <Typography
              variant="body1"
              sx={{
                ml: 2,
                whiteSpace: 'pre-line',
                fontStyle: 'italic',
                fontSize: '12px',
                color: 'gray',
                marginTop: { xs: '8px', md: '0' },
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              {testoBenvenuto}
            </Typography>
          </Box>
          <Box>

            {isOp ? <div /> : <Tooltip title="Richiedi Consulenza Studio Romeo">
              <IconButton disabled={!risposta} onClick={() => setOpenDialogConferma(true)} color="primary">
                <HelpOutline />
              </IconButton>
            </Tooltip>}

            {isOp ? <div /> : <Tooltip title="Inizia Nuova Richiesta">
              <IconButton onClick={() => setNuovaDialogAperta(true)} color="primary">
                <Add />
              </IconButton>
            </Tooltip>}

            <Tooltip title="Storico Richieste">
              <IconButton onClick={() => setDashboardAperta(true)} color="primary">
                <History />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* Area di input e selettori */}
        <Paper elevation={3} sx={{
          p: 3,
          borderRadius: 4,
          backgroundColor: "#fff"
        }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2}>
              <TextField
                select
                label="Categoria"
                fullWidth
                value={categoria}
                disabled={!!risposta || isOp}
                onChange={(e) => setCategoria(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Work />
                    </InputAdornment>
                  ),
                }}
              >
                {categorie.map((cat) => (
                  <MenuItem key={cat} value={cat}>{cat}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                select
                label="Regione"
                fullWidth
                value={regione}
                disabled={!!risposta || isOp}
                onChange={(e) => setRegione(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationOn />
                    </InputAdornment>
                  ),
                }}
              >
                {regioni.map((reg) => (
                  <MenuItem key={reg} value={reg}>{reg}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={7}>
              <TextField
                label="Descrizione"
                placeholder="Descrivi brevemente il ruolo e le mansioni"
                fullWidth
                disabled={!!risposta || isOp}
                value={descrizione}
                onChange={(e) => setDescrizione(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Description />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={1}>
              <IconButton
                color="primary"
                onClick={handleInvia}
                disabled={!categoria || !regione || !descrizione || scrittura || risposta || isOp}
                sx={{
                  backgroundColor: '#e3f2fd',
                  width: '100%',
                  height: '56px',
                  borderRadius: '12px'
                }}
              >
                <Send />
              </IconButton>
            </Grid>
          </Grid>
        </Paper>

        {/* Risposta e Circular*/}
        <Box mt={4} display="flex" flexDirection="column" alignItems="center">
          {scrittura ? (
            <Box mt={4} display="flex" flexDirection="column" alignItems="center">
              <CircularProgress size={50} thickness={4} />
              <Typography variant="body1" mt={2} fontWeight="medium">
                Stiamo elaborando i dati, potrebbe volerci qualche minuto...
              </Typography>
            </Box>
          ) : (
            mostraRisposta && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                style={{ width: "100%" }}
              >
                <Paper
                  elevation={4}
                  sx={{
                    p: 4,
                    backgroundColor: '#f0f4f8',
                    borderRadius: '16px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <Typography variant="h6" gutterBottom fontWeight="bold">
                    Risposta:
                  </Typography>
                  <Typography
                    component="div"
                    sx={{
                      whiteSpace: 'pre-wrap',
                      fontFamily: 'monospace',
                      color: '#333',
                    }}
                  >
                    <ReactMarkdown>{risposta}</ReactMarkdown>
                  </Typography>
                </Paper>
              </motion.div>
            )
          )}
        </Box>

      </Box>

      {/* Dashboard Storico Richieste */}
      {dashboardAperta && (
        <Dashboard
          conversazioni={conversazioni}
          eliminaConversazione={eliminaConversazione}
          onClose={() => setDashboardAperta(false)}
          visualizzaItem={visualizzaItemFun}
          ragioniSociali={ragioniSociali}
          isOp={isOp}
        />
      )}

      {/* Dialog di conferma per la consulenza */}
      <Dialog open={openDialogConferma} onClose={() => setOpenDialogConferma(false)}>
        <DialogTitle>Conferma Richiesta di Consulenza</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Sei sicuro di voler richiedere una consulenza?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialogConferma(false)} color="inherit">
            Annulla
          </Button>
          <Button onClick={() => handleRichiediConsulenza(conversazioni[conversazioni.length - 1].id)} variant="contained" color="primary" autoFocus>
            Conferma
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog nuova richiesta */}
      <Dialog open={nuovaDialogAperta} onClose={() => setNuovaDialogAperta(false)}>
        <DialogTitle>Nuova richiesta</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            Vuoi iniziare una nuova previsione? I dati attuali verranno resettati.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNuovaDialogAperta(false)} color="inherit">
            Annulla
          </Button>
          <Button onClick={avviaNuovaRichiesta} variant="contained" color="primary">
            Conferma
          </Button>
        </DialogActions>
      </Dialog>

      {/* Conferma Richiesta Consulenza Verde */}
      <Snackbar
        open={!!successMessage}
        autoHideDuration={3000}
        onClose={() => setSuccessMessage("")}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <SnackbarContent
          sx={{
            backgroundColor: 'green',
            color: 'white',
            fontWeight: 'bold',
          }}
          message={successMessage}
        />
      </Snackbar>

      {/* Snack per Errori Rosso */}
      <Snackbar
        open={!!error}
        autoHideDuration={3000}
        onClose={() => setError("")}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <SnackbarContent
          sx={{
            backgroundColor: 'red',
            color: 'white',
            fontWeight: 'bold',
          }}
          message={error}
        />
      </Snackbar>
    </Box>
  );
}
